module.exports = __webpack_public_path__ + "img/freediving-7.53a52603.jpeg";